export const fontMixin = {
  data () {
    return {}
  },
  mounted () {},
  computed: {},
  methods: {
    $_addFont (componentFont) {
      if (
        componentFont &&
        componentFont.family &&
        componentFont.files &&
        componentFont.files.length > 0 &&
        componentFont.files[0].fontUrl) {
        const font = componentFont.family
        const url = componentFont.files[0].fontUrl
        const junctionFont = new FontFace(`${font}`, `url(${url})`)
        junctionFont.load().then(function (loadedFace) {
          document.fonts.add(loadedFace)
        }).catch(function (error) {
          console.log('Error Loading Font', error)
        })
      }
    },
    $_getFontStyle (componet, target) {
      const elementFontData = componet &&
        componet[target] &&
        componet[target].fontSetup ? componet[target].fontSetup : null
      if (elementFontData) {
        this.$_addFont(elementFontData)
        return {
          '--font-family': `${elementFontData && elementFontData.family ? elementFontData.family : null}`,
          '--font-weight': `${elementFontData && elementFontData.weight ? elementFontData.weight : null}`,
          '--font-size': `${elementFontData && elementFontData.size ? elementFontData.size + 'px' : null}`
        }
      } else {
        return null
      }
    }
  }
}
